// extracted by mini-css-extract-plugin
module.exports = {"header":"HeadContainer_header__2shOr"};